import { Stack } from '@mui/material';
import React from 'react';
import TypographyText from './table/TypographyText';
import { useAppSelector } from '../../store';
import ShowContainer from './ShowContainer';
import { formatNumber } from '../../utils';

export default function CurrencyValue({
  value,
  defaultValue = '',
  currency,
  fontWeight,
  isFormatNumber,
  justifyContent,
  fontSize
}) {
  const currencies = useAppSelector((state) => state.user.info.currency);

  const decimal = currencies[currency]?.decimal || 2;
  const decimalValue = value?.toFixed?.(decimal);
  const displayValue = (decimalValue ? +decimalValue : decimalValue) ?? defaultValue;

  return (
    <Stack direction={'row'} gap={0.5} justifyContent={justifyContent}>
      <TypographyText fontWeight={fontWeight} fontSize={fontSize}>
        {isFormatNumber ? formatNumber(displayValue) : displayValue}
      </TypographyText>
      <ShowContainer condition={displayValue || defaultValue}>
        <TypographyText color="textSecondary" fontWeight={fontWeight} fontSize={fontSize}>
          {currency || ''}
        </TypographyText>
      </ShowContainer>
    </Stack>
  );
}
